import { AfterViewInit, Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
	selector: '[appCollapsible]'
})
export class CollapsibleDirective implements OnInit, AfterViewInit {

	isCollapsedValue = true;
	isViewInitialised = false;

	@Input()
	set isCollapsed(value: boolean) {
		this.isCollapsedValue = value;
		this.doAnimate();
	}

	constructor(private elementRef: ElementRef, private renderer: Renderer2) {
	}

	ngOnInit(): void {
	}

	ngAfterViewInit(): void {
		this.isViewInitialised = true;
		this.renderer.setStyle(this.elementRef.nativeElement, 'transition', 'height 0.3s linear');
		if (this.isCollapsedValue) {
			this.renderer.setStyle(this.elementRef.nativeElement, 'height', '0');
		} else {
			this.renderer.setStyle(this.elementRef.nativeElement, 'height', 'auto');
		}
	}

	doAnimate(): void {
		if (this.isViewInitialised) {
			if (this.isCollapsedValue) {
				this.onCollapse();
			} else {
				this.onExpand();
			}
		}
	}

	onExpand(): void {
		const element = this.elementRef.nativeElement;
		// get the height of the element's inner content, regardless of its actual size
		const sectionHeight = element.scrollHeight;

		// have the element transition to the height of its inner content
		element.style.height = sectionHeight + 'px';

		const eventFunc = () => {
			// remove this event listener so it only gets triggered once
			element.removeEventListener('transitionend', eventFunc);

			// remove "height" from the element's inline styles, so it can return to its initial value
			element.style.height = null;
		};

		// when the next css transition finishes (which should be the one we just triggered)
		element.addEventListener('transitionend', eventFunc);

		// mark the section as "currently not collapsed"
		element.setAttribute('data-collapsed', 'false');
	}

	onCollapse(): void {
		const element = this.elementRef.nativeElement;
		// get the height of the element's inner content, regardless of its actual size
		const sectionHeight = element.scrollHeight;

		// temporarily disable all css transitions
		const elementTransition = element.style.transition;
		element.style.transition = '';

		// on the next frame (as soon as the previous style change has taken effect),
		// explicitly set the element's height to its current pixel height, so we
		// aren't transitioning out of 'auto'
		requestAnimationFrame(() => {
			element.style.height = sectionHeight + 'px';
			element.style.transition = elementTransition;

			// on the next frame (as soon as the previous style change has taken effect),
			// have the element transition to height: 0
			requestAnimationFrame(() => {
				element.style.height = 0 + 'px';
			});
		});

		// mark the section as "currently collapsed"
		element.setAttribute('data-collapsed', 'true');
	}
}
